import React from 'react';
import Fade from 'react-reveal/Fade';

import { TextComponent } from 'design/text/textComponents';
import { useIntlDictionary } from 'hooks/useIntlDictionary';
import { PressControlComponent } from 'design/pressControl';
import { ANIMATION_DEFAULT_DURATION } from 'utils/constants';
import { ContentLayoutComponent } from 'design/contentLayout';
import { MarginComponent } from 'design/margin';
import { EmailSupportLink } from 'containers/EmailSupportLink';
import { TelegramSupportLink } from 'containers/TelegramSupportLink';
import { useIsMobile } from 'hooks/useIsMobile';

type Props = {
  error: Error;
  restore(): void;
};

export const DemoStackManagerErrorFallback = (props: Props) => {
  const { restore } = props;

  const { demoStackManager: ownDictionary } = useIntlDictionary();

  const isMobile = useIsMobile();

  return (
    <Fade duration={ANIMATION_DEFAULT_DURATION}>
      <ContentLayoutComponent
        title={
          <TextComponent size="l" family="futura">
            {ownDictionary.demoFailedTitleText}
          </TextComponent>
        }
        body={
          <>
            {ownDictionary.demoFailedDescriptionText(
              <EmailSupportLink />,
              <TelegramSupportLink />
            )}
            <MarginComponent top={48} />
            <PressControlComponent
              type="button"
              theme="primary"
              fill={isMobile}
              onPress={restore}
            >
              {ownDictionary.demoFailedActionText}
            </PressControlComponent>
          </>
        }
        backAction={null}
      />
    </Fade>
  );
};
